export const UP_KEY = 38
export const DOWN_KEY = 40
export const ENTER_KEY = 13
export const TAB_KEY = 9
